interface Props {
  guestName: string;
  closingMessage: string | null;
  accentColor: string;
  onBack: () => void;
}

export default function GuestBookThankYou({ guestName, closingMessage, accentColor, onBack }: Props) {
  return (
    <div className="flex flex-col items-center text-center space-y-6 py-8 px-4">
      {/* Animated checkmark */}
      <div
        className="w-20 h-20 flex items-center justify-center rounded-full"
        style={{ backgroundColor: accentColor + "15" }}
      >
        <div
          className="w-14 h-14 flex items-center justify-center rounded-full"
          style={{ backgroundColor: accentColor }}
        >
          <i className="ri-check-line text-white text-3xl"></i>
        </div>
      </div>

      {/* Message */}
      <div className="space-y-2">
        <h2 className="text-2xl font-bold text-slate-800" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
          ¡Gracias, {guestName}!
        </h2>
        <p className="text-slate-500 text-sm leading-relaxed">
          Tu mensaje quedó guardado en el libro de firmas.
        </p>
      </div>

      {/* Closing message */}
      {closingMessage && (
        <div
          className="w-full rounded-2xl px-5 py-4 text-sm leading-relaxed italic"
          style={{ backgroundColor: accentColor + "10", color: accentColor, borderLeft: `3px solid ${accentColor}40` }}
        >
          &ldquo;{closingMessage}&rdquo;
        </div>
      )}

      {/* Divider ornament */}
      <div className="flex items-center gap-3 w-full">
        <div className="flex-1 h-px bg-slate-100"></div>
        <span className="text-slate-300 text-lg">❧</span>
        <div className="flex-1 h-px bg-slate-100"></div>
      </div>

      {/* Actions */}
      <div className="flex flex-col w-full gap-3">
        <button
          onClick={onBack}
          className="w-full flex items-center justify-center gap-2 py-3.5 rounded-2xl border-2 font-semibold text-sm transition-all cursor-pointer whitespace-nowrap"
          style={{ borderColor: accentColor + "40", color: accentColor }}
        >
          <i className="ri-arrow-left-line"></i>
          Dejar otro mensaje
        </button>
        <button
          onClick={() => {
            navigator.clipboard.writeText(window.location.href).catch(() => {});
          }}
          className="w-full flex items-center justify-center gap-2 py-3.5 rounded-2xl bg-slate-100 hover:bg-slate-200 font-semibold text-sm text-slate-600 transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-share-line"></i>
          Compartir con otros invitados
        </button>
      </div>

      {/* Branding */}
      <p className="text-xs text-slate-300 mt-2">
        Creado con <span className="font-semibold">Pixory AI</span>
      </p>
    </div>
  );
}